import React from 'react';
import axios from 'axios';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";

import Table from "../../components/Table/index";

class TakenAwardList extends React.Component {
  constructor(props) {
    super(props);
    moment.locale('cs');

    const columns = [{
      id: 'user',
      Header: 'Uživatel',
      accessor: (d) => d.userId ? `${d.userId.nickname} (${d.userId.firstname} ${d.userId.surname})` : `Smazaný uživatel`
    }, {
      id: 'award',
      Header: 'Odměna',
      accessor: 'awardId.name',
    }, {
      Header: 'Datum vyzvednutí',
      accessor: 'createdAt',
      sortMethod: (a, b) => {
        if (moment(a) < moment(b)) return -1;
        if (moment(a) > moment(b)) return 1;
        return 0;
      },
      Cell: row => moment(row.original.createdAt).format('LLL')
    }];

    const tableOptions = {
      showPagination: true,
      showPageSizeOptions: true,
      showPageJump: true,
      collapseOnSortingChange: true,
      collapseOnPageChange: true,
      collapseOnDataChange: true,
      freezeWhenExpanded: false,
      filterable: true,
      sortable: true,
      resizable: true,
      defaultPageSize: 10,
      defaultSorted: [{
        id: 'createdAt',
        desc: true
      }]
    };

    this.state = {
      userAwards: [],
      columns,
      tableOptions
    };

  }

  componentDidMount() {
    const { accessToken } = this.props.sessionData;
    if (accessToken) {
      this.getUserAwards();
    }
  };

  getUserAwards() {
    this.setState({
      tableOptions: {
        ...this.state.tableOptions,
        loading: true
      }
    });
    const loginToken = this.props.sessionData.accessToken;
    const config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    axios.get(this.props.api.userAwards, config)
      .then((result) => {
        this.setState({
          userAwards: result.data,
          tableOptions: {
            ...this.state.tableOptions,
            loading: false
          }
        });
      }).catch((error) => {
      console.log("Axios error: ", error);
    });
  }

  render() {

    const { columns, tableOptions } = this.state;
    let { userAwards } = this.state;

    return (
      <div className="x-panel">
        <div className="x-title">
          <h2>Seznam vyzvednutých odměn</h2>
          <div className="clearfix" />
        </div>
        <div className="x-content">
          <Table
            columns={columns}
            data={userAwards}
            tableOptions={tableOptions}
            defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
            options={{}}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(TakenAwardList);



/** WEBPACK FOOTER **
 ** ./src/containers/TakenAwards/TakenAwardList.js
 **/